module.exports = __webpack_public_path__ + "static/img/Rectangle287.0e3bf37a.png";